import type { ListingBedBathSqftLabelsData } from 'components/listing-card/listing-bed-bath-sqft-labels';
import type { ComplianceProps, ListingCardData } from 'types/listing-card';

export type ComplianceData = ComplianceProps;
export type SimilarListing = ListingCardData & ComplianceData;
export type ComparableListing = ListingBedBathSqftLabelsData;

export enum SimilarListingsComponentUsage {
  Similar = 'Similar',
  Comparable = 'Comparable',
  HomeAppraisalSold = 'Home Appraisal Sold',
  HomeAppraisalAvailable = 'Home Appraisal Available'
}